{
  "common" : {
    "customFieldExistsError" : "Champ personnalisé avec ce nom existe déjà",
    "uniqueKeyNotUniqueError" : "Cette clé n'est pas unique",
    "save" : "Sauvegarder",
    "saving" : "Sauvegarde en cours",
    "integrate" : "Intégrer",
    "preview" : "Aperçu",
    "back" : "Retour",
    "alert" : "Alerte",
    "proceed" : "Poursuivre",
    "cancel" : "Annuler",
    "delete" : "Supprimer",
    "embed" : "Intégrer",
    "link" : "Lien",
    "iframeEmbed" : "Intégration Iframe",
    "styles" : "Styles",
    "options" : "Options",
    "quickAdd" : "Ajout rapide",
    "customFields" : "Champs personnalisés",
    "personalInfo" : "Information personnelle",
    "contactInfo" : "Coordonnées",
    "submit" : "Soumettre",
    "address" : "Adresse",
    "customized" : "Sur mesure",
    "layout" : "Mise en page",
    "showLabel" : "Afficher l’étiquette",
    "background" : "Arrière-plan",
    "buttonBackground" : "Contexte du Bouton",
    "fontColour" : "Couleur de la Police",
    "textFontColour" : "Text Font Colour",
    "subTextFontColour" : "Sub Text Font Colour",
    "selectThemes" : "Sélectionner un thème",
    "filled" : "Rempli",
    "textOnly" : "Corps uniquement",
    "border" : "Bordure",
    "borderType" : "Type de bordure",
    "cornerRadius" : "Rayon de l'angle",
    "width" : "Largeur",
    "padding" : "Remplissage",
    "top" : "Haut",
    "bottom" : "Bas",
    "left" : "Gauche",
    "right" : "Droite",
    "center" : "Centre",
    "default" : "Par défaut",
    "formDefault" : "Formulaire par défaut",
    "shadow" : "Ombre",
    "color" : "Couleur",
    "horizontal" : "Horizontal",
    "vertical" : "Vertical",
    "blur" : "Flou",
    "spread" : "Diffusion",
    "fieldStyle" : "Style de champ",
    "fontColor" : "Couleur de la police",
    "inputTextFillColor" : "Couleur de remplissage du texte de la zone de saisie",
    "inputTextColor" : "Couleur du texte de la zone de saisie",
    "primaryColor" : "Couleur primaire",
    "primaryColorTooltip" : "Contrôle la couleur pour l’état de survol et l’état actif.",
    "inputTextColorTooltip" : "Contrôle la couleur du texte saisi dans les champs.",
    "mapPrimaryColorToButtonColor" : "Associer la couleur primaire à la couleur du bouton",
    "label" : "Étiquette",
    "fontFamily" : "Famille de polices",
    "size" : "Taille",
    "weight" : "Poids",
    "placeholder" : "Espace réservé",
    "customCSS" : "CSS personnalisé",
    "backgroundImage" : "Image d’arrière-plan",
    "headerImage" : "Image d'en-tête",
    "miscellaneous" : "Divers",
    "agencyBranding" : "Image de marque de l’agence",
    "imageUploadMessage" : "Cliquez ou faites glisser un fichier vers cette zone pour le téléverser.",
    "backgroundImageTooltipMessage" : "L'image d'arrière-plan est destinée à couvrir toute la page, offrant ainsi une toile de fond visuellement attrayante pour le formulaire. Pour afficher l’image d’arrière-plan, cliquez sur l’option Aperçu.",
    "headerImageTooltipMessage" : "L’image d’en-tête est conçue pour couvrir toute la largeur du formulaire et reste positionnée en haut du formulaire. Pour afficher l'image d'en-tête, cliquez sur l'option Aperçu.",
    "onSubmit" : "Lors de la soumission",
    "facebookPixelID" : "Identifiant de pixel Facebook",
    "facebookPixelIDMessage" : "Ignorez ce champ si vous prévoyez d'utiliser ce formulaire/cette enquête dans un entonnoir.",
    "facebookPixelEvents" : "Événements du pixel Facebook",
    "onpageView" : "Affichage sur la page",
    "stickyContact" : "Contact collant",
    "stickyContactMessage" : "Remembers and auto-fills contact details when the user returns on the same device and browser.",
    "fieldDescription" : "Description du champ",
    "fieldTitle" : "Titre du champ",
    "queryKey" : "Clé de requête",
    "querykeyTooltipMessage" : "La clé de requête peut être utilisée comme paramètre URL pour remplir ce champ.",
    "required" : "Obligatoire",
    "hidden" : "Caché",
    "hiddenValue" : "Valeur cachée",
    "enableCountryPicker" : "Activer le sélecteur de pays",
    "altText" : "Texte de remplacement",
    "alignment" : "Alignement",
    "imageWidth" : "Largeur de l’image",
    "imageHeight" : "Hauteur de l'image",
    "logic" : "Logique",
    "pleaseInput" : "Veuillez saisir",
    "editHTML" : "Modifier l'HTML",
    "textStyle" : "Style du texte",
    "subText" : "Sous-texte",
    "text" : "Texte",
    "buttonStyle" : "Style du bouton",
    "fullWidth" : "Pleine largeur",
    "htmlMessage" : "Placez le code HTML personnalisé ici.",
    "htmlEditorHeader" : "JAVASCRIPT / HTML PERSONNALISÉ",
    "htmlEditorBodyMessage" : "Ajoutez votre code ici.",
    "yesSave" : "Oui, sauvegarder",
    "cancelKeep" : "Annuler, conserver",
    "done" : "Terminé",
    "addElement" : "Ajouter un élément",
    "addUrlLike" : "Ajoutez des URL valides comme",
    "doNotAddRelativePath" : "N'ajoutez pas de chemins relatifs comme",
    "or" : "ou",
    "addCustomFields" : "Ajouter des champs personnalisés",
    "customFieldSearch" : "Recherche par nom",
    "enterSourceValue" : "Saisis la valeur source",
    "shortLabel" : "Étiquette courte",
    "shortLabelPlaceholder" : "Police",
    "labelPlaceholder" : "Type une étiquette",
    "fileUploadPlaceholder" : "Téléverser un fichier",
    "customCSSTooltip" : "La feuille de style personnalisée a préséance sur le style de forme et les thèmes et peut avoir un impact sur le style du thème.",
    "fontFamilyTooltip" : "Le générateur prend en charge tous les types de polices si vous ne les voyez pas dans la liste. Veuillez la rechercher dans le menu déroulant.",
    "useGDPRCompliantFont" : "Utilisez une police conforme au RGPD.",
    "enableTimezone" : "Activer le fuseau horaire",
    "inputStyle" : "Style d’entrée",
    "conditionalLogicAlertOnSubmit" : "La logique conditionnelle aura préséance sur le message / rediriger ici.",
    "conditionalLogicAlertOnShowHide" : "La logique conditionnelle aura préséance sur les paramètres cachés ici.",
    "placeholderFacebookPixelIdInput" : "Saisir l'identifiant de pixel Facebook",
    "doNotShowMessage" : "Ne plus afficher",
    "creatingForm" : "OK",
    "creatingSurvey" : "Créez votre Sondage...",
    "creatingQuiz" : "Créez votre quiz...",
    "errorCreatingForm" : "Une erreur s'est produite lors de votre formulaire. Veuillez réessayer.",
    "errorCreatingSurvey" : "Là a été une erreur Veuillez réessayer.",
    "errorCreatingQuiz" : "Une erreur s'est produite lors de la création de votre quiz. Veuillez réessayer.",
    "redirectMessage" : "You will be redirected to:",
    "themes" : {
      "themes" : "Thèmes",
      "alertThemeMessage" : "Le changement de thème entraîne la perte de toutes les modifications de style en cours.",
      "useTheme" : "Utiliser le thème",
      "removeTheme" : "Supprimer le thème"
    },
    "box" : "Case",
    "line" : "Ligne",
    "message" : "Message",
    "openUrl" : "Ouvrir l'URL",
    "borderTypeList" : {
      "dotted" : "Pointillés",
      "dashed" : "Tiretés",
      "solid" : "Ligne continue",
      "none" : "Aucun"
    },
    "button" : "Bouton",
    "emailNotification" : "Notification par courriel",
    "emailNotificationSubheader" : "Recevoir un courriel lorsque quelqu'un remplit votre formulaire",
    "subject" : "Objet",
    "emailTo" : "Courriel (À)",
    "senderName" : "Nom de l’expéditeur",
    "senderNameWarning" : "Votre (nom de sous-compte) sera ajouté si ce champ est laissé vide.",
    "emailError" : "Au moins une adresse courriel est obligatoire",
    "emailTooltip" : "La première adresse courriel est désignée pour le champ « À ». Toutes les adresses courriel ultérieures seront incluses dans le champ « Cc ».",
    "clear" : "Effacer",
    "showNotificationsSettings" : "Afficher les paramètres des notifications",
    "emailServicePaid" : "Cette fonctionnalité est un service payant et entraînera des frais en fonction de votre utilisation.",
    "integration" : "Intégration",
    "validation" : {
      "fieldRequired" : "Champ est obligatoire",
      "maxLengthExceeded" : "Max' accord ({max}"
    },
    "payment" : {
      "payments" : "Paiements",
      "connected" : "Connecté",
      "connect" : "Se connecter",
      "liveModeOn" : "Mode en direct",
      "status" : "Statut",
      "test" : "Essai",
      "live" : "En direct",
      "paymentFields" : "Champs de paiement",
      "suggestAnAmount" : "Proposer un montant",
      "selectCurrency" : "Sélectionner la devise",
      "tagActiveBGColor" : "Couleur de l'étiquette active",
      "includeOtherAmount" : "Inclure l'autre montant",
      "footerInfo" : "Informations de pied de page",
      "paymentType" : "Type de paiement",
      "sellProducts" : "Vendre des produits",
      "customAmount" : "Montant personnalisé",
      "collectPayment" : "Percevoir le paiement",
      "generalSettings" : "Champs généraux",
      "securePayments" : "* 100 %.",
      "error" : {
        "addMainProductFirst" : "Ajoutez un produit PRIMAIRE en premier",
        "priceNotFoundForBumpProduct" : "Prix trouvé pour le Produit à bosses",
        "productAlreadyAdded" : "Produit déjà ajouté"
      },
      "product" : {
        "addProduct" : "Ajouter un produit",
        "productSettings" : "Paramètres du produit",
        "selectProduct" : "Sélectionner un produit",
        "editThisProduct" : "Pour modifier ce produit",
        "clickHere" : "Cliquez ici",
        "show" : "Afficher",
        "description" : "Description",
        "image" : "Image",
        "layoutSettings" : "Paramètres de mise en page",
        "singleColumn" : "Colonne unique",
        "twoColumn" : "Deux colonnes",
        "threeColumn" : "Trois colonnes",
        "maxProductError" : "Nombre maximal de 20 produits autorisés dans un formulaire",
        "productSelectPlaceholder" : "Veuillez sélectionner un produit.",
        "orderConfirmation" : "Confirmation de commande",
        "orderConfirmationWarning" : "Une page de confirmation de commande s'affichera une fois le paiement effectué.",
        "quantity" : "Quantité",
        "createProduct" : "Pour créer un produit",
        "noProductsAdded" : "Aucun produit ajouté pour le moment",
        "productsWillShowHere" : "Une fois que vous avez inclus des produits, ils s'afficheront ici",
        "chooseProductType" : "Sélectionner Typede produit",
        "mainProduct" : "PRIMAIRE"
      },
      "bumProduct" : {
        "price" : "Prix",
        "variant" : "Variante",
        "headline" : "Titre",
        "otoHeadline" : "OTO Titre",
        "otoText" : "OK",
        "enableImage" : "Activer Image",
        "imageMessage" : "Nous saisirons l' Image par défaut",
        "orUploadADifferentImage" : "Téléverser une autre Image",
        "bumpProducts" : "Produits à bosses",
        "bumpProduct" : "Produit à bosses",
        "enableBump" : "Activer le bosse",
        "orderBumpStyle" : "Personnaliser le Style",
        "classic" : "Classique",
        "modern" : "Aujourd'hui",
        "icon" : "Icône",
        "bumpTemplate" : "Sélectionner un Modèle",
        "highlightText" : "Mise en page du corps",
        "showPrice" : "Afficher le Prix",
        "bumpPriceColor" : "Prix à bosses",
        "bumpIconColor" : "Icône à bosses",
        "bumpBackgroundColor" : "Contexte de la bosse",
        "highlightTextColor" : "Mise en page du corps",
        "headlineColor" : "Titre",
        "otoHeadlineColor" : "OTO Titre",
        "otoTextColor" : "OK",
        "bumpBorderColor" : "Bordure de la bosse",
        "priceRequired" : "Le prix est obligatoire",
        "headlineRequired" : "Le titre est obligatoire",
        "bumpProductTooltip" : "Une . Les clients peuvent l'inclure avec un .",
        "templateOne" : "Modèle 1",
        "templateTwo" : "Modèle 2",
        "templateThree" : "Modèle 3",
        "animationIcon" : {
          "none" : "Aucun",
          "arrow" : "Flèche",
          "fire" : "Incendre",
          "plus" : "Plus",
          "giftBox" : "Boîte à cocher",
          "timer" : "Compte à rebours",
          "cracker" : "Catégorisation",
          "snack" : "Collant",
          "partyBalloon" : "Groupe de danse",
          "flash" : "Instantané",
          "money" : "Monnaie",
          "spaceShuttle" : "Transfert de Espace"
        }
      },
      "coupons" : {
        "coupons" : "Coupons",
        "enableCoupon" : "Activer le coupon",
        "couponAlignment" : "Alignement des coupons",
        "left" : "Gauche",
        "right" : "Droite",
        "fullWidth" : "Pleine largeur",
        "tooltipMessage" : "Définir la position de l'entrée du coupon à partir des types ci-dessous"
      }
    },
    "addressSettings"  : {
      "autoComplete"  : "Remplissage automatique de l'adresse",
      "addressfields"  : "Champs d'adresse",
      "placeholderSearch"  : "Rechercher une adresse",
      "autoCompleteTooltip"  : "Permet de rechercher et de remplir automatiquement une adresse.",
      "streetAddress"  : "Adresse de la rue",
      "autoCompleteAddressTitle"  : "Finir Auto l'adresse",
      "newBadge"  : "Nouveau",
      "defaultLabel"  : "Adresse",
      "searchPlaceholder"  : "Rechercher des adresses",
      "mandataorySearch"  : {
        "title"  : "Obligatoire pour l'adresse in la barre de recherche",
        "primaryText"  : "Remplissage automatique uniquement pour Adresse de la rue",
        "secondaryText"  : "Quand il est activé, lorsqu'un utilisateur interagir avec le champ d'adresse, Ensuite, ils doivent comporter une adresse valide pour continuer.",
        "secondaryText1"  : "in"
      }
    },
    "autoResponder" : "Répondeur automatique",
    "autoResponderSubheader" : "Envoyez un courriel automatique à la personne qui soumet le formulaire (le courriel comprend une copie des renseignements saisis dans le formulaire).",
    "replyToEmail" : "Réponse au courriel",
    "open" : "Ouvert",
    "won" : "Réussi",
    "lost" : "Perdu",
    "abandon" : "Abandonner",
    "selectAPipeline" : "Sélectionner un pipeline",
    "stage" : "Étape",
    "status" : "Statut",
    "opportunityValue" : "Valeur de l’opportunité",
    "createNewPipeline" : "Créer un nouveau pipeline",
    "editOpportunitySettings" : "Modifier les paramètres de l'opportunité",
    "contact" : "Contact",
    "opportunity" : "Opportunité",
    "add" : "Ajouter",
    "more" : "Plus",
    "opportunityHeading" : "Où voulez-vous que votre opportunité soit mise à jour?",
    "date" : {
      "dateSettings" : "Paramètres de date",
      "dateFormat" : "Format de la date",
      "dateSeparator" : "Séparateur de date",
      "dateFormatTooltipMessage" : "Sélectionnez un format de date. D représente le jour, M les mois et Y l'année",
      "dateSeparatorTooltipMessage" : "Sélectionnez un séparateur qui séparera le jour, le mois et l'année dans le format sélectionné dans Format de la date.",
      "disablePicker" : "Désactiver le sélecteur"
    },
    "restoreVersion" : "Restaurer la version",
    "versionHistory" : "Historique de la version",
    "errorMessage" : "Erreur, réessayez",
    "version" : "Version :",
    "currentVersion" : "Version actuelle",
    "messageStyling" : "Style du message",
    "validateEmailHeader" : "Valider le courriel",
    "validateEmailDescription" : "Le bouton sera visible une fois que l'utilisateur aura saisi son courriel. Cette fonctionnalité est conçue pour vous aider à générer des prospects de qualité.",
    "validatePhoneHeader" : "Valider le numéro de téléphone",
    "validatePhoneDescription" : "Le bouton sera visible une fois que l'utilisateur aura saisi son numéro de téléphone. Cette fonctionnalité est conçue pour vous aider à générer des prospects de qualité.",
    "validatePhoneWarning" : "Pour activer la vérification par mot de passe unique reçu par SMS, assurez-vous que votre numéro de téléphone est configuré dans tes paramètres de localisation.",
    "addAnotherTnc" : "Add another T & C",
    "tnc1" : "T & C 1",
    "tnc2" : "T & C 2",
    "deleteCaps" : "DELETE",
    "deleteConfirmation" : "Type DELETE to confirm",
    "style" : {
      "formLayoutType" : "Type de formulaire",
      "layoutType" : "Layout Type",
      "surveyType" : "Survey Type",
      "oneColumn" : "Une colonne",
      "twoColumn" : "Deux colonnes",
      "singleLine" : "Ligne unique",
      "fieldWidth" : "Largeur du champ",
      "labelAlignment" : {
        "labelAlignment" : "Alignement des étiquettes",
        "labelWidth" : "Largeur de l'étiquette"
      },
      "fieldSpacing"  : "Espacement des champs",
      "color"  : "couleur",
      "fontColor"  : "Couleur de la police",
      "inputBackground"  : "Arrière-plan de l'entrée",
      "inputBackgroundColor" : "Couleur d'arrière-plan de la zone de saisie",
      "inputBorder" : "Bordure de la zone de saisie",
      "layout"  : "Mise en page",
      "colorsAndBackground"  : "Couleurs et arrière-plan",
      "advanceSettings"  : "Réglages avancés",
      "inputField"  : "Champ de saisie",
      "borderWidth"  : "Largeur de la bordure",
      "borderColor"  : "Couleur de bordure",
      "borderStyle"  : "Style de bordure",
      "fontSize"  : "Taille de la police",
      "fontWeight"  : "Poids de la police",
      "labelColor"  : "Couleur de l’étiquette",
      "placeholderColor"  : "Couleur de l'espace réservé",
      "shortLabelColor"  : "Couleur de l’étiquette courte"
    },
    "replyToTooltip" : "Personnalisez l'adresse courriel de réponse par défaut en utilisant {'{'}{'{'}contact.email{'}'}{'}'} pour permettre de répondre au contact qui soumet le formulaire.",
    "content" : "Contenu",
    "calculations" : "Calculs",
    "uploadOptions" : "Options de téléversement",
    "opportunitySettingsWarning" : "Veuillez configurer les paramètres d’opportunité en cliquant sur le bouton Modifier les paramètres d’opportunité.",
    "question" : "Question",
    "createContactOnPartialSubmission" : "Créer un contact lors de la soumission partielle",
    "howItWorks" : "Comment ça fonctionne?",
    "createContactOnPartialSubmissionDescription" : "Terminez la diapositive et cliquez sur « Suivant ». Un nouveau contact sera automatiquement créé et enregistré.",
    "swapWarningMessageSurvey" : "La modification ou le changement d'options aura un impact sur ce champ personnalisé partout où le champ est utilisé. Cela peut également réinitialiser la logique conditionnelle. ",
    "swapWarningMessageForm" : "La modification ou le changement d'options aura un impact sur ce champ personnalisé partout où le champ est utilisé. ",
    "migrationWarningMessage" : "This functionality has been migrated to the Survey Conditional Logic.",
    "optionLabel" : "Étiquette d'option",
    "calculationValue" : "Valeur de calcul",
    "addOption" : "Ajouter une option",
    "enableCalculations" : "Activer les calculs",
    "allowOtherOption" : "Allow Other Option",
    "productSelectionSubtext" : "Individuel sur la sélection de plusieurs produits",
    "multi" : "Plusieurs",
    "single" : "Individuel",
    "productSelectionHeading" : "Sélection du Produit",
    "spreadToColumns" : "Diffusion aux colonnes",
    "columns" : "Colonnes",
    "customstyle" : "Style",
    "standard" : "Standard",
    "bubble" : "Bubble",
    "integratePopup" : {
      "embedCode" : "Embed Code",
      "useInFunnelOrEmbedCode" : "Use in Funnel/ Embed Code",
      "iframeEmbed" : "Embarquer Iframe",
      "funnel" : {
        "funnel" : "Entonnoir",
        "chooseStep" : "Sélectionner une étape",
        "copyCodeAndOpenFunnel" : "Copie le Code et Ouvert Entonnoir"
      },
      "share" : {
        "share" : "Share",
        "shareViaSocials" : "Partager via les Réseaux sociaux",
        "copyLink" : "Copier le lien"
      },
      "email" : {
        "email" : "Courriel",
        "shareViaEmail" : "Partager via Courriel",
        "emailButton" : "Courriel",
        "blankTemplate" : "Format d' Modèle",
        "emailMarketingTemplates" : "Modèles de Marketing par Courriel",
        "or" : "Ou",
        "chooseTemplate" : "Choose from your templates",
        "continue" : "Continuer"
      }
    },
    "rating" : {
      "icon" : "Icône",
      "iconAlignment" : "Alignement des Icône",
      "count" : "Nombre",
      "lowestRating" : "Évaluation Min",
      "highestRating" : "Évaluation Max",
      "iconSelectedState" : "Icône État Sélectionné",
      "iconUnselectedState" : "Icône de État non sélectionné",
      "rating" : "Évaluation",
      "ratingSettings" : "Réglages Évaluation",
      "calculationType" : {
        "calculationType" : "Comment Évaluation les domaines in des domaines personnalisés",
        "calculationTypeTooltip" : "Quand vous enregistrez un message",
        "absolute" : "Total",
        "percentage" : "Pourcentage",
        "fraction" : "Fraction"
      }
    },
    "desktopMode" : "Mode bureau",
    "mobileMode" : "Mode mobile",
    "versions" : "Variantes",
    "advanced" : "Advanced",
    "edit" : "Edit",
    "settings" : "Settings",
    "submissions" : "Submissions",
    "undo" : "Undo",
    "redo" : "Redo",
    "confirmationMessage" : "Confirmation Message",
    "deleteOption" : "Supprimer l’option",
    "deleteConfirmationModal" : {
      "defaultDescription" : "Supprimer une option aura un impact sur ce Champ Voulez-vous vraiment le supprimer?",
      "validationMessage" : "Veuillez saisir pour enregistrer.",
      "validationError" : "Veuillez saisir Supprimer"
    },
    "disqualifyImmediately" : "Disqualify Immediately",
    "disqualifyAfterSubmit" : "Disqualify After Submit",
    "generalSettings" : "Réglages Général",
    "advancedSettings" : "Réglages avancés",
    "customFieldName" : "Nom de l'entreprise",
    "customFieldNameTooltip" : "Ce nom d'entreprise est unique par .",
    "uniqueKey" : "Clé unique",
    "uniqueKeyTooltip" : "Cette clé est unique par l'entreprise.",
    "survey" : {
      "layoutType" : "Survey Type",
      "oneQuestionPerPage" : "One Question at a Time",
      "allQuestionsOnePage" : "Many at a Time"
    },
    "quizQuestions" : "Demande de quiz",
    "choiceElements" : "Sélections des composants",
    "otherElements" : "Autres composants",
    "listEditor" : {
      "prefillValueHeader" : "Pré-remplir la Valeur",
      "labelPlaceholder" : "Étiquette",
      "valuePlaceholder" : "Valeur",
      "optionRequiredError" : "Le Champ d'options est obligatoire"
    },
    "field" : "Champ",
    "scoreEditor" : {
      "addFieldPlaceholder" : "Ajouter un Champ",
      "fieldLabel" : "Champ",
      "numberLabel" : "nombre"
    },
    "fileUploadEditor" : {
      "fileTypes" : "Type de Fichier",
      "all" : "Tout",
      "pdf" : "PDF",
      "docxDoc" : "D'UTILISATEUR",
      "png" : "PNG",
      "gif" : "GIF",
      "jpgJpeg" : "JPG/JPG",
      "xlsCsv" : "CSV"
    },
    "ok" : "OK",
    "select" : "Sélectionner",
    "allowMultipleFiles" : "Plusieurs fichiers actifs",
    "maxFileLimit" : "Limite Max de Fichier",
    "privacyPolicy" : "Confidentialité",
    "termsOfService" : "Terme de service"
  },
  "fields" : {
    "quizQuestions" : {
      "singleChoice" : "Sélection individuelle",
      "multipleChoice" : "Sélection multiples de choix",
      "yesNo" : "Oui / Non",
      "shortAnswer" : "Réponse à la Cour",
      "longAnswer" : "Longueur de la réponse",
      "number" : "nombre",
      "singleDropdown" : "Liste individuelle",
      "multiDropdown" : "Plusieurs Liste déroulante"
    },
    "personal" : {
      "fullName" : "Nom Plein",
      "firstName" : "Prénom",
      "lastName" : "Dernière nom",
      "dateOfBirth" : "Date de naissance",
      "phone" : "Téléphone",
      "email" : "Gmail"
    },
    "submit" : {
      "button" : "Bouton"
    },
    "integration" : {
      "sellProducts" : "Vendre des produits",
      "collectPayment" : "Percevoir le Paiement"
    },
    "address" : {
      "address" : "Adresse",
      "streetAddress" : "Adresse de la rue",
      "city" : "Ville",
      "state" : "État",
      "country" : "Pays",
      "postalCode" : "Code postal",
      "organization" : "Groupe",
      "website" : "Site Web",
      "websitePlaceholder" : "Placez l'URL du site Web ici."
    },
    "text" : {
      "singleLine" : "Ligne individuelle",
      "multiLine" : "Plusieurs Ligne",
      "textBoxList" : "Liste Carré du texte"
    },
    "choiceElements" : {
      "singleDropdown" : "Liste individuelle",
      "multiDropdown" : "Plusieurs Liste déroulante",
      "checkbox" : "Case à cocher",
      "radio" : "Radio"
    },
    "customized" : {
      "text" : "Texte",
      "html" : "HTML",
      "htmlPlaceholder" : "Placez le code HTML Personnalisé ici.",
      "captcha" : "Majuscule",
      "source" : "Source",
      "termsAndConditions" : "T et C",
      "termsAndConditionsPlaceholder" : "J'accepte les conditions générales via l'entreprise. via l'envoi de mon",
      "score" : "Pointage"
    },
    "other" : {
      "image" : "Image",
      "fileUpload" : "Téléverser du Fichier",
      "monetary" : "Monétaire",
      "number" : "nombre",
      "datePicker" : "Sélecteur de Date",
      "signature" : "Signataire"
    },
    "customstyle" : "Style",
    "standard" : "Standard",
    "bubble" : "Bubble"
  },
  "survey" : {
    "typeOfBuilder" : "Enquête",
    "survyeStyle" : "Style d'enquête",
    "surveyName" : "Nom de l'enquête",
    "surveyElement" : "Élément de l'enquête",
    "addSurveyElement" : "Ajouter un élément d'enquête",
    "cloneSlide" : "Cloner la diapositive",
    "unsavedAlertMessage" : "L'enquête comporte un travail non enregistré. Voulez-vous vraiment quitter et perdre tout travail non enregistré?",
    "thirdPartyScriptAlertMessage" : "Les scripts tiers placés dans le bloc HTML peuvent offrir des fonctionnalités puissantes, mais ils présentent également des risques pour la confidentialité, la sécurité, les performances et le comportement de la page. Par conséquent, nous vous recommandons de vérifier le contenu de ce script avant de l'enregistrer dans l'enquête.",
    "integrateHeader" : "Intégrer le sondage",
    "integrateSubHeader" : "Utilisez les options suivantes pour intégrer votre enquête personnalisée dans votre site Web.",
    "integrateCopyLinkMessage" : "Copiez le lien ci-dessous et partagez-la facilement à l'endroit souhaité.",
    "onSurveySubmission" : "Lors de la soumission de l'enquête",
    "surveySettings" : "Paramètres de l'enquête",
    "oneQuestionAtTime" : "Une question à la fois",
    "backButton" : "Bouton Retour",
    "backButtonTooltipMessage" : "Back button will help users to move to the previous slide",
    "disableAutoNavigation" : "Désactiver la navigation automatique",
    "disableAutoNavigationTooltipMessage" : "Naviguez automatiquement vers les .",
    "autoNavigation" : "Navigation Auto",
    "autoNavigationTooltipMessage" : "Naviguez automatiquement vers les .",
    "progressBar" : "Barre de progression",
    "progressBarTooltipMessage" : "Turning this off will remove the Progress Bar from the survey",
    "disableAnimation" : "Désactiver l'animation",
    "disableAnimationTooltipMessage" : "Si vous activez cette option, l'animation de transition entre diapositives sera désactivée.",
    "scrollToTop" : "Faire défiler jusqu'en haut",
    "scrollToTopTooltipMessage" : "Si vous activez cette fonction, l'enquête défilera vers le haut de la diapositive suivante.",
    "footerHTML" : "HTML de pied de page",
    "footerHTMLMessage" : "Vous pouvez écrire des feuilles de style personnalisées (en utilisant la balise de style) et du HTML dans la même case.",
    "editFooter" : "Modifier le pied de page",
    "disqualifySettings" : "Disqualify Settings",
    "disqualifyImmediately" : "Disqualifier immédiatement",
    "disqualifyAfterSubmit" : "Disqualifier après soumission",
    "disqualifyImmediatelyLabel" : "Immediately",
    "disqualifyAfterSubmitLabel" : "After Submit",
    "slideConflictAlertMessage" : "Cette diapositive contient plusieurs questions qui ont une logique définie. Cela peut entraîner des comportements non intentionnels.",
    "addSlide" : "Ajouter une diapositive",
    "settings" : "Paramètres",
    "delete" : "Supprimer",
    "slideDeleteAlertMessage" : "Voulez-vous vraiment supprimer cette diapositive?",
    "slideDeleteBetweenAlertMessage" : "Cela réorganisera les autres diapositives. Voulez-vous vraiment supprimer cette diapositive?",
    "slideLabel" : "Slide {n}",
    "slideName" : "Nom de la diapositive",
    "slidePosition" : "Position de la diapositive",
    "jumpTo" : "Aller à",
    "jumpToSubText" : "Jump to a specific slide",
    "enableTimezoneSurvey" : "Si vous activez cette option, l'information de fuseau horaire de la personne qui soumet l'enquête sera capturée.",
    "footer" : {
      "footer" : "Pied de page",
      "enableNewFooter" : "Activer le nouveau pied de page",
      "stickToSurvey" : " Joindre à l'enquête",
      "backgroundFill" : "Remplissage d’arrière-plan",
      "footerHeight" : "Hauteur du pied de page",
      "enableProgressBar" : "Activer la barre de progression",
      "buttons" : "Boutons",
      "button" : "Bouton",
      "buttonType" : "Type de bouton",
      "fillNext" : "Remplir (suivant)",
      "fillPrevious" : "Remplir (précédent)",
      "fillSubmit" : "Remplissage (Soumettre)",
      "textColor" : "Texte du bouton",
      "position" : "Position",
      "previousText" : "Précédent (texte)",
      "nextText" : "Suivant (texte)",
      "submitText" : "Soumettre (texte)",
      "fillComplete" : "Remplissage terminé",
      "fillInactive" : "Remplissage inactif",
      "footerType" : "Type de pied de page",
      "stickToCard" : "Joindre à la carte",
      "stickToPage" : "Joindre à la page",
      "stepTextColor" : "Étape de la couleur du corps",
      "progressBarFill" : "Remplir de la Barre de progression",
      "progressBarInactive" : "Barre de progression Inactif",
      "arrowFill" : "Remplir de la Flèche",
      "submitColorMobile" : "Soumettre (Couleur)",
      "arrowFillColor" : "Couleur de la couleur"
    },
    "surveyNotfication" : "Notification d’enquête",
    "style" : {
      "surveyPadding" : "Remplissage de l'enquête"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Embed or Share Survey",
      "share" : {
        "openFormLink" : "Ouvert le Lien de Sondage"
      },
      "email" : {
        "emailSubheader" : "Créez un courriel vide et intégration de votre Sondage, sortant un modèle et l'intégration immédiatement."
      }
    },
    "autoResponderSubheader" : "Envoyez un courriel automatisé à la personne qui soumet l'enquête (le courriel comprend une copie des renseignements saisis dans l'enquête).",
    "switchToOneQuestionAtTimeOn" : "L'activation d' « Une Question à une Date» bloque votre logique conditionnelle actuelle.",
    "switchToOneQuestionAtTimeOff" : "Désactiver « Une Question à une Date» a un impact sur votre logique conditionnelle Config",
    "switchToOneQuestionAtTimeOnWarning" : "Certains conditions ne fonctionneront plus comme Date.",
    "switchToOneQuestionAtTimeOffWarning" : " Toutes les conditions conçue pour le Débit sur des questions cesseront de fonctionner comme prévu.",
    "createContactOnPartialSubmissionSubText" : "Creates a contact when a user clicks \"Next\" on any slide — even if they don't finish the Survey."
  },
  "form" : {
    "typeOfBuilder" : "Formulaire",
    "formStyle" : "Style de formulaire",
    "formElement" : "Élément de formulaire",
    "addFormElement" : "Ajouter un élément de formulaire",
    "addConditionalLogic" : "Ajouter une logique conditionnelle",
    "openConditionalLogic" : "Open Conditional Logic",
    "inlineForm" : "Formulaire en ligne",
    "formName" : "Nom du formulaire",
    "fullScreenMode" : "Mode plein écran",
    "fullScreenModetooltip" : "Si vous activez cette fonction, le formulaire s'étendra sur toute la largeur de son conteneur, s'étirant jusqu'au bord de la zone d'intégration tout en adhérant à la largeur du formulaire.",
    "enableTimezoneForm" : "Si vous activez cette option, l'information de fuseau horaire de la personne qui soumet le formulaire sera capturée.",
    "formSettings" : "Paramètres du formulaire",
    "unsavedAlertMessage" : "Le formulaire comporte un travail non enregistré. Voulez-vous vraiment quitter et perdre tout travail non enregistré?",
    "thirdPartyScriptAlertMessage" : "Les scripts tiers placés dans le bloc HTML peuvent offrir des fonctionnalités puissantes, mais ils présentent également des risques pour la confidentialité, la sécurité, les performances et le comportement de la page. Par conséquent, nous vous recommandons de vérifier le contenu de ce script avant de l'enregistrer dans le formulaire.",
    "onFormSubmission" : "Lors de la soumission du formulaire",
    "integrateForm" : "Intégrer le formulaire",
    "embedlayoutType" : "Embarquer le Type de Mise en page",
    "embedlayoutTypeSubMessage" : "Sélectionnez une mise en page à intégrer dans un entonnoir ou un site Web externe.",
    "triggerType" : "Type de déclencheur",
    "showOnScrolling" : "Afficher lors du défilement",
    "showAfter" : "Afficher après",
    "seconds" : "secondes",
    "alwaysShow" : "Toujours afficher",
    "activationOptions" : "Options d'activation",
    "activateOn" : "Activer lors de",
    "visit" : "visite",
    "alwaysActivated" : "Toujours activé",
    "deactivationOptions" : "Options de désactivation",
    "deactivateAfterShowing" : "Désactiver après affichage",
    "times" : "fois",
    "deactiveOnceLeadCollected" : "Désactiver une fois le client potentiel collecté",
    "neverDeactivate" : "Ne jamais désactiver",
    "copyEmbedCode" : "Copier le code d'intégration",
    "copyFormLink" : "Copier le lien du formulaire",
    "openFormLink" : "Ouvrir le lien du formulaire",
    "inline" : "Intégré",
    "inlineDescription" : "Un formulaire intégré apparaît avec le contenu de la page en tant qu'élément d'origine. Il ne se superpose pas et ne peut pas être fermé ou réduit au minimum.",
    "inlineHoverDescription" : "Un formulaire intégré apparaît avec le contenu de la page en tant qu'élément d'origine. Il ne se superpose pas et ne peut pas être fermé ou réduit au minimum.",
    "popup" : "Fenêtre contextuelle",
    "popupDescription" : "Une fenêtre contextuelle affiche le formulaire sous la forme d'une superposition à l'intérieur d'une case lumineuse. Cette dernière ne peut pas être réduite, mais peut être fermée.",
    "popupHoverDescription" : "Une fenêtre contextuelle affiche le formulaire sous la forme d'une superposition à l'intérieur d'une case lumineuse. Cette dernière ne peut pas être réduite, mais peut être fermée.",
    "politeSlideIn" : "Formulaire coulissant",
    "politeSlideInDescription" : "Un formulaire coulissant apparaît en bas de l'écran et disparaît une fois fermé.",
    "politeSlideInHoverDescription" : "Apparaît en bas de l'écran et disparaît une fois fermé.",
    "stickySidebar" : "Barre latérale épinglée",
    "stickySidebarDescription" : "Une barre latérale épinglée apparaît sur le côté de l'écran et peut être réduite à un onglet épinglé sur le côté de la fenêtre.",
    "stickySidebarHoverDescription" : "Apparaît sur le côté de l'écran et peut être réduite à un onglet épinglé sur le côté de la fenêtre.",
    "allowMinimize" : "Permettre de réduire",
    "conditonalLogic" : {
      "conditions" : "Conditions",
      "noExistingCondition" : "Aucune condition existante pour le moment",
      "freeRoamMessage" : "Vous êtes libre de vous déplacer sans règles, du moins pour l'instant.",
      "addNewCondition" : "Ajouter une nouvelle condition",
      "redirectToUrl" : "Rediriger vers une URL",
      "displayCustomMessage" : "Afficher un message personnalisé",
      "disqualifyLead" : "Disqualifier le prospect",
      "showHideFields" : "Afficher/Masquer les champs",
      "jumpTo" : "Jump To",
      "redirectToUrlSubText" : "Rediriger la soumission d'utilisateurs",
      "displayCustomMessageSubText" : "Afficher les messages en fonction des entrées de l'utilisateur",
      "disqualifyLeadSubText" : "Filtre les entrées dans des conditions spécifiques",
      "showHideFieldsSubText" : "Modifier la Visibilité",
      "openBelowUrl" : "Ouvrir l'URL ci-dessous",
      "showCustomMessage" : "Afficher un message personnalisé",
      "alertConditionDelete" : "Voulez-vous vraiment supprimer cette condition?",
      "deleteCondition" : "Supprimer la condition",
      "conditionExecutedMessage" : "Les conditions seront exécutées de haut en bas.",
      "allOperationOptions" : {
        "isEqualTo" : "Est égal à",
        "isNotEqualTo" : "N'est pas égal à",
        "contains" : "Contient",
        "startsWith" : "Commence par",
        "endsWith" : "Se termine par",
        "isEmpty" : "Est vide",
        "isFilled" : "Est rempli",
        "before" : "Avant",
        "after" : "Après",
        "greaterThan" : "Supérieur à",
        "lessThan" : "Inférieur à"
      },
      "logic" : {
        "if" : "Si",
        "then" : "Puis",
        "and" : "Et",
        "or" : "Ou"
      },
      "phoneAlertMessage" : "Pour rechercher des numéros de téléphone avec un code de pays, vous devez inclure explicitement le symbole « + » dans votre requête de recherche.",
      "deleteAlertMessage" : "Voulez-vous vraiment supprimer ce champ? La condition associée à ce champ sera également supprimée.",
      "deleteField" : "Supprimer le champ",
      "jumpToDescription" : "Jump to a specific slide when conditions are met",
      "jumpToSlide" : "Jump To Slide",
      "selectSlideToJumpTo" : "Select slide to jump to",
      "selectedSlide" : "Selected slide"
    },
    "minimizedTitlePlaceholder" : "Titre réduit",
    "dragYourElementFromLeft" : "Faites glisser vos éléments ici à partir de la gauche.",
    "formNotification" : "Notification de formulaire",
    "style" : {
      "formPadding" : "Remplissage de formulaire"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Embed or Share Form",
      "share" : {
        "openFormLink" : "Ouvert le Lien du Formulaire"
      },
      "email" : {
        "emailSubheader" : "Créez un courriel vide et equerrez votre formulaire, ou ."
      }
    },
    "choosePosition" : "Sélectionner du statut"
  },
  "quiz" : {
    "quizElement" : "Élément de quiz",
    "quizNotification" : "Notification de questionnaire",
    "viewAndCustomise" : "Voir et personnaliser",
    "categoryAndScore" : "Catégorie et score",
    "provideFeedback" : "Fournir des commentaires",
    "addQuizElement" : "Ajouter un élément de quiz",
    "typeOfBuilder" : "Questionnaire",
    "addQuestions" : "Ajouter des questions",
    "dragAndDropQuestion" : "Traîner et supprimer un élément de Question ici.",
    "addNewPage" : "Ajouter une nouvelle Page",
    "editTemplate" : "Modifier le Modèle",
    "clonePage" : "Clone Page",
    "category" : {
      "category" : "Catégorie",
      "watchVideo" : "Voir cette vidéo pour en Page plus.",
      "useCategoryWhen" : "Utiliser des catégories Quand",
      "manageCategories" : "Gérer les Catégories",
      "howItWorks" : "Comment fonctionne ce travail?",
      "howItWorks2" : "Comment fonctionne ce travail",
      "addCategoryMessage" : "Ajouter une nouvelle catégorie",
      "assignCategoryMessage" : "Attribuer une catégorie à tous les options",
      "editResultsMessage" : "Afficher le score in la Page des résultats",
      "addCategory" : "Ajouter une Catégorie",
      "deleteCategoryAlertMessage" : "La Supprimer d'une catégorie entraînera le retour de cette catégorie in toutes les Options",
      "editOrAddNewCategories" : "Vous pouvez modifier ou inclure de nouveaux catégories",
      "toEvaluateTheResponder" : "Pour Comparer le Répondeur en fonction de plusieurs facteurs",
      "showMultipleCategoryScore" : "Afficher plusieurs catégories in la Page des résultats",
      "displayVaryingContent" : "Affichage de la Page de résultats en fonction de l'affichage du niveau de score",
      "theOptionFieldIsRequired" : "The option field is required",
      "addManage" : "Ajouter / Gérer"
    },
    "quizSettings" : "Paramètres du quiz",
    "onQuizSubmission" : "Lors de la soumission du questionnaire",
    "settings" : "Paramètres",
    "deletePage" : "Supprimer la page",
    "quizResult" : {
      "resultTemplate" : "Modèle de résultat",
      "quizResultAlertMessage" : "La page de résultats choisie s'affichera une fois le questionnaire terminé."
    },
    "autoResponderSubheader" : "Envoyez un courriel automatisé à la personne qui soumet le questionnaire (le courriel comprend une copie des renseignements qu’elle a saisis dans le questionnaire).",
    "integrateHeader" : "Intégrer le quiz",
    "integrateSubHeader" : "Utilisez les options suivantes pour intégrer votre questionnaire personnalisé dans votre site Web.",
    "integrateCopyLinkMessage" : "Copiez le lien ci-dessous et partagez-le facilement à l'endroit souhaité.",
    "pageLabel" : "Page {n}",
    "pageName" : "Nom de la page",
    "pagePosition" : "Position de la page",
    "createContactOnPartialSubmissionSubText" : "Creates a contact when a user clicks \"Next\" on any slide — even if they don't finish the Quiz.",
    "integratePopup" : {
      "shareOrEmbed" : "Embed or Share Quiz",
      "share" : {
        "openFormLink" : "Ouvert le Lien du quiz"
      },
      "email" : {
        "emailSubheader" : "Créez un courriel vide et intégrer votre quiz."
      }
    }
  }
}
